import AppDispatcher from '../dispatcher/AppDispatcher';
import { EventEmitter } from 'events';
import assign from 'object-assign';
import Constants from '../constants/Constants';

const CHANGE_EVENT = 'change'; // globālais

let _flashMessages = [];
const FlashMessageStore = assign({}, EventEmitter.prototype, {
  emitChange() {
    this.emit(CHANGE_EVENT);
  },

  /**
	 * @param {function} callback
	 */
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },

  /**
	 * @param {function} callback
	 */
  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },

  add(id, type, message, options) {
    _flashMessages.push({
      id, type, message, options,
    });
  },

  removeAll() {
    _flashMessages = [];
  },

  getAll() {
    return _flashMessages;
  },

  getLast() {
    if (_flashMessages.length) {
      return _flashMessages.pop();
    }
    return {};
  },
});

module.exports = FlashMessageStore;
